import { ReactNode } from 'react';

export const inputClass = `
  text-sh-navy focus:border-sh-navy block h-[47px] w-full rounded-none
  border border-[#69727d] bg-transparent px-4 py-[6px] font-sans text-[16px]
  leading-[1.4] tracking-[0.016em] placeholder:text-[#9a9a9a] focus:outline-none
`;

const labelClass = `
  text-sh-navy mb-2 block font-sans text-[12px] leading-none font-normal
  tracking-[0.03em]
`;

type FieldProps = {
  id: string;
  label: string;
  error?: string;
  children: (props: {
    errorId: string | undefined;
    invalid: boolean;
  }) => ReactNode;
};

export function Field({ id, label, error, children }: FieldProps) {
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div>
      <label htmlFor={id} className={labelClass}>
        {label}*
      </label>
      {children({ errorId, invalid: !!error })}
      {error && (
        <p id={errorId} className='text-sh-orange mt-1 font-sans text-[12px]'>
          {error}
        </p>
      )}
    </div>
  );
}
